module.exports = __webpack_public_path__ + "img/support.a2883266.svg";